module.exports = __webpack_public_path__ + "static/media/barcode_error.ebf10043.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/barcode_error.svg
// module id = 126
// module chunks = 1